import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ContactsService } from 'src/app/business-service/contacts/contacts.service';
import { VisaService } from 'src/app/business-service/visa/visa.service';
import { GlobalService } from 'src/app/modules/shared/services/global/global.service';
import { ComponentReloadService } from 'src/app/modules/shared/services/reload/component-reload.service';
import { ResponseNotificationService } from 'src/app/modules/shared/services/response-notification/response-notification.service';
import { InputValidationsService } from 'src/app/modules/shared/services/validations/input-validations.service';

@Component({
  selector: 'app-lead-details',
  templateUrl: './lead-details.component.html',
  styleUrls: ['./lead-details.component.scss'],
})
export class LeadDetailsComponent  implements OnInit {

  @Input() visaId:any;
  @Input() leadId: any;
  @Input() storedFormData: any;

  @Input() editVisaId: any;

  @Output() viewChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() storeFormData: EventEmitter<any> = new EventEmitter<any>();
  @Output() storeDocumentsFormData: EventEmitter<any> = new EventEmitter<any>();
  @Output() assignVisaId: EventEmitter<any> = new EventEmitter<any>();

  visaDetailsForm!: FormGroup;

  // TODO: use LOV data
    visaTypes: any = [
    {
      name: 'Tourist Visa',
      key: 'Tourist Visa'
    },
    {
      name: 'Business Visa',
      key: 'Business Visa'
    },
    {
      name: 'Student Visa',
      key: 'Student Visa'
    },
    {
      name: 'Transit Visa',
      key: 'Transit Visa'
    },
    {
      name: 'Work Visa',
      key: 'Work Visa'
    },
    {
      name: 'Family Visa',
      key: 'Family Visa'
    },
    {
      name: 'PR Visa',
      key: 'PR Visa'
    }
  ]

  applicantTypes: any = [
    {
      name: 'Retired',
      key: 'Retired'
    },
    {
      name: 'Employee',
      key: 'Employee'
    },
    {
      name: 'Self Employed',
      key: 'Self Employed'
    },
    {
      name: 'Student',
      key: 'Student'
    }
  ]

  nationality: any = [
    {
      name: "Indian",
      key: "Indian"
    },
    {
      name: "American",
      key: "American"
    },
    {
      name: "Other",
      key: "Other"
    }
  ]
  constructor(
    private _fb: FormBuilder,
    private _globalService: GlobalService,
    private _validationService: InputValidationsService,
    private _visaService: VisaService,
    private _responseService: ResponseNotificationService,
    private _contactsService: ContactsService,
    private _reloadService: ComponentReloadService
  ) { }

  async ngOnInit() {
    this.visaDetailsForm = this._fb.group({
      destination: ['', [Validators.required]],
      nights: [0],
      totalAdults: [0],
      totalChildrens: [0],
      totalPassengers: [0],
      startDate: [null],
      endDate: [null],
      passengerInfo: this._fb.array([]),
      note: [''],
      visaId: [null],
      leadId: [this.leadId],
      id: [null],
      createdBy: [''],
      createDate: [''],
      organizationId: [null],
      ownershipRole: ['']
    });

    // Getting contacts of lead and patching to existing passenger PI info
    if(!this.storedFormData){
      let contacts = await this.getContactsOfLead();
      this.patchContactDetailsInPassengerInfo(contacts);
    }
    

    this.visaDetailsForm.valueChanges.subscribe(()=>{
      this.visaDetailsForm.markAsTouched();
    })

    this.visaDetailsForm.get('totalPassengers')?.valueChanges.subscribe((value)=>{
      this.updatePassengerCount(value);
    })

    this.visaDetailsForm.get('startDate')?.valueChanges.subscribe(startDate => this.updateEndDate());
    this.visaDetailsForm.get('nights')?.valueChanges.subscribe(nights => this.updateEndDate());

    if(this.storedFormData){
      this.patchVisaLedFormData(this.storedFormData);
    }
  }

  ngOnChanges(){
    this.ngOnInit();
  }

  get today():Date{
    let date = new Date();
    date.setHours(0, 0, 0, 0);
    return date;
  }

  convertToDate(value: any): Date{
    return new Date(value);
  }

  async getContactsOfLead(): Promise<any[]> {
    // TODO: get all contacts irrespective of page size
    try {
      // Fetch contacts with await
      const contacts = await this._contactsService.getAllContactsForLead(this.leadId, 1, 10, null).toPromise();
      return contacts.data; // Return the contacts
    } catch (error) {
      console.error('Error fetching contacts:', error);
      throw error; // Propagate the error
    }
  }

  patchContactDetailsInPassengerInfo(contacts:any){
    const passengerInfoArray = this.passengerInfoArray();
    // Patching total passenger
    this.visaDetailsForm.get('totalPassengers')?.setValue(contacts.length);

    contacts.forEach((contact: any, index: number) => {
      if (passengerInfoArray.length <= index) {
        passengerInfoArray.push(this.createPassengerInfo());
      }
      // contact.dateOfBirth = contact.dateOfBirth ? this.convertToDate(contact.dateOfBirth): null;      
      passengerInfoArray.at(index).patchValue({
        ...contact,
        firstName: contact.firstName,
        lastName: contact.lastName,
        dateOfBirth:  contact.dateOfBirth ? this.convertToDate(contact.dateOfBirth): null,
        gender: contact.gender || '',
        nationality: contact.nationality || '',
        visaType: contact.visaType || '',
        applicantType: contact.applicantType|| ''
      });
    });
  }
  

  updatePassengerCount(totalPassengers: any) {
      
    const passengerInfoArray = this.passengerInfoArray();
  
    // Adjust the FormArray size to match the total number of guests
    while (passengerInfoArray.length < totalPassengers) {
      passengerInfoArray.push(this.createPassengerInfo());
    }
  
    while (passengerInfoArray.length > totalPassengers) {
      passengerInfoArray.removeAt(passengerInfoArray.length - 1);
    }    
  }
  

  passengerInfoArray(): FormArray{
    return this.visaDetailsForm.get('passengerInfo') as FormArray;
  }

  createPassengerInfo():FormGroup{
    let group = this._fb.group({
      firstName: [''],
      lastName: [''],
      dateOfBirth: [''],
      age: [''],
      gender: [''],
      nationality: [''],
      contactId: [''],
      id: [null],
      createdBy: [''],
      createDate: [''],
      organizationId: [null],
      ownershipRole: [''],
      visaType: [''],
      applicantType: [''],
    });

     // Add a subscription to calculate age based on DOB
     group.get('dateOfBirth')?.valueChanges.subscribe((dob: any) => {
      if (dob) {
        const calculatedAge = this._globalService.calculateAge(this._globalService.formatDateTimeToDate(dob));
        group.get('age')?.setValue(calculatedAge);
        this.updateAdultsAndChildrenCount();
      }
    });

    return group;
  }

  updateAdultsAndChildrenCount(){
    const passengerInfoArray = this.passengerInfoArray();
    let totalAdults = 0;
    let totalChildren = 0;
    passengerInfoArray.controls.forEach((passenger: any) => {
      if(passenger.get('dateOfBirth').value){
        let age = this.calculateAge(passenger.get('dateOfBirth').value);
        if(age && age > 2){
          totalAdults++;
        }else{
          totalChildren++;
        }
      }
    });

    this.visaDetailsForm.get('totalAdults')?.setValue(totalAdults);
    this.visaDetailsForm.get('totalChildrens')?.setValue(totalChildren);
  }

  calculateAge(dateOfBirth: string | Date): number {
    const birthDate = new Date(dateOfBirth);
    const currentDate = new Date();
  
    let age = currentDate.getFullYear() - birthDate.getFullYear();
  
    // Adjust the age if the birthday hasn't occurred yet this year
    const hasBirthdayPassed =
      currentDate.getMonth() > birthDate.getMonth() ||
      (currentDate.getMonth() === birthDate.getMonth() &&
        currentDate.getDate() >= birthDate.getDate());
  
    if (!hasBirthdayPassed) {
      age--;
    }
  
    return age;
  }
  

  private updateEndDate(): void {
    const startDate = this.visaDetailsForm.get('startDate')?.value;
    let totalNights = this.visaDetailsForm.get('nights')?.value;
  
    if (startDate && totalNights) {
      const startDateFormat: Date = new Date(startDate);
      
      const endDate = new Date(startDateFormat);
      endDate.setDate(startDateFormat.getDate() + totalNights);
      
      this.visaDetailsForm.get('endDate')?.setValue(endDate, { emitEvent: false });
    }
  }

  patchVisaLedFormData(formData: any){
    this.visaDetailsForm.patchValue({
      ...formData,
      totalPassengers: (formData.totalAdults || 0) + (formData.totalChildrens || 0),
      startDate: formData.startDate ? this.convertToDate(formData.startDate):null,
      endDate: formData.endDate ? this.convertToDate(formData.endDate):null,
    })
    if(formData.passengerInfo?.length){
      this.patchPassengerInfo(formData.passengerInfo);
    }
  }

  patchPassengerInfo(passengerInfo: any){
    const passengerInfoArray = this.passengerInfoArray();
    passengerInfo.forEach((passenger: any, index: number) => {
      if (passengerInfoArray.length <= index) {
        passengerInfoArray.push(this.createPassengerInfo());
      }
      passenger.dateOfBirth = passenger.dateOfBirth ? this.convertToDate(passenger.dateOfBirth): null;
      passengerInfoArray.at(index).patchValue(passenger);
    });
  }

  checkTableCellEmpty(formControlName:string, index: number){
    let value = this.passengerInfoArray().at(index).get(formControlName)?.value;
    return value === "" || value === null || value === undefined;
  }

  async onSubmit(): Promise<boolean> {
    if (this.visaDetailsForm.valid) {
      try {
        const formData = await this.serializeFormData(this.visaDetailsForm.value);  
        const data = await this._visaService.addVisaLeadInformation(formData).toPromise();
        this._responseService.showMessage("Visa Information Added Successfully");
        this._reloadService.triggerVisaLeadReload();
        this.visaDetailsForm.markAsPristine();
        data.dataSaved = true;
        this.assignVisaId.emit(data.visaLeadInfo?.visaId);
        this.storedFormData = data.visaLeadInfo;
        this.storeFormData.emit(data.visaLeadInfo);
        this.storeDocumentsFormData.emit(data.visaDocuments);
        return true;
      } catch (error) {
        console.error("Error while adding visa info", error);
        this._responseService.showMessage("Failed to add Visa Information", true);
        return false;
      }
    } else {
      this.visaDetailsForm.markAllAsTouched();
      this._globalService.scrollToFirstInvalidControl();
      this._globalService.customAlert("Fill all required fields to save", "Invalid Form");
      return false;
    }
  }
  

  async serializeFormData(formData: any) {        
    let serializedData = {
      ...formData,
      destination: formData.destination.name,
      passengerInfo: formData.passengerInfo
        ? formData.passengerInfo.map(({ age, dateOfBirth, ...rest }: any) => ({
            ...rest,
            dateOfBirth: dateOfBirth ? this._globalService.convertDateToString(dateOfBirth) : null,
          })) : [],
      documentCollectionLink: this.storedFormData?.documentCollectionLink || ""
    };
    
    return serializedData;
  }

  async resetForm(){
    if(await this._globalService.confirmActionPopup("Confirm to reset data", "Confirm", "Confirm")){
      this.ngOnInit();
    }    
  }

  goPrevious(){
    this.viewChange.emit(true);
  }

  goNext(){
    this.viewChange.emit(false);
  }

  async saveAndNext(){
    if(await this.onSubmit()){
      this.goNext()
    }
  }

  formDataModified(): boolean {
    return (this.visaDetailsForm.dirty || this.visaDetailsForm.invalid) && this.visaDetailsForm.touched;
  }

}
